<template>
  <div class="main">
    <Problem :son="20" :questions="questions" />
  </div>
</template>

<script>
import Problem from '@/components/experimentation/problem .vue'
export default {
  components: { Problem },
  data() {
    return {
      questions: [
        {
          id: 0,
          question: 'lang.mz.two.questions.first.question',
          options: [
            { value: 'A', label: 'lang.mz.two.questions.first.options.A' },
            { value: 'B', label: 'lang.mz.two.questions.first.options.B' },
            { value: 'C', label: 'lang.mz.two.questions.first.options.C' },
            { value: 'D', label: 'lang.mz.two.questions.first.options.D' },
          ],
          answer: '',
          result: 'A',
          score: 2,
          scored: 0,
        },
        {
          id: 1,
          question: 'lang.mz.two.questions.second.question',
          options: [
            { value: 'A', label: 'lang.mz.two.questions.second.options.A' },
            { value: 'B', label: 'lang.mz.two.questions.second.options.B' },
            { value: 'C', label: 'lang.mz.two.questions.second.options.C' },
            { value: 'D', label: 'lang.mz.two.questions.second.options.D' },
          ],
          answer: '',
          result: 'B',
          score: 2,
          scored: 0,
        },
      ],
    }
  },
}
</script>